/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum DiscoveryPageWizardTypes {
    InstallAndUpdateVBRWizard = 'InstallAndUpdateVBRWizard',
}
